import { WasteForm, WasteFormItem, WasteLocation } from "../models/WasteFormModels";

export default class WasteScreenState {
    wasteForms: WasteForm[] = [];
    wasteFormItems: WasteFormItem[] = [];
    wasteLocations?: WasteLocation[] = [];
    selectedForm?: number;
    selectedLocationId?: number;
    selectedLocation?: string;          // name of the selected location   
}